module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "top": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        _vm.moduleToAddName = null;
        _vm.moduleToAddType = 'personal';
        _vm.moduleToAddTeam = null;
        _vm.addDialog = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-subheader', [_vm._v("Personal modules")]), _vm._v(" "), _vm._l((_vm.sorted(_vm.userModules)), function(module, index) {
    return [_c('v-list-tile', {
      key: module.id,
      class: {
        'red': module.id == _vm.selectedModuleId, 'lighten-4': module.id == _vm.selectedModuleId
      },
      attrs: {
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.selectModule(module.id)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": _vm.iconColor(module)
      }
    }, [_vm._v(_vm._s(_vm.iconName(module)))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(module.name))]), _vm._v(" "), (module.locked_date) ? _c('v-list-tile-sub-title', [_vm._v("locked on " + _vm._s(_vm.moment(module.locked_date).format('YYYY-MM-DD, HH:mm')))]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "disabled": !!module.locked_date
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moduleToLock = _vm.clone(module);
          _vm.lockDialog = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "green lighten-1"
      }
    }, [_vm._v("lock")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moduleToDelete = _vm.clone(module);
          _vm.deleteDialog = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("delete")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.userModules.length) ? _c('v-divider', {
      key: module.id + '-'
    }) : _vm._e()]
  }), _vm._v(" "), (_vm.userModules.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "60px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.teamModulesDict), function(teamModules, teamId) {
    return [_c('v-divider'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v(_vm._s(_vm.teamDescription(teamId)))]), _vm._v(" "), _vm._l((teamModules), function(module, index) {
      return [_c('v-list-tile', {
        key: module.id,
        class: {
          'red': module.id == _vm.selectedModuleId, 'lighten-4': module.id == _vm.selectedModuleId
        },
        attrs: {
          "ripple": ""
        },
        on: {
          "click": function($event) {
            _vm.selectModule(module.id)
          }
        }
      }, [_c('v-list-tile-action', [_c('v-icon', {
        attrs: {
          "color": _vm.iconColor(module)
        }
      }, [_vm._v(_vm._s(_vm.iconName(module)))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(module.name))]), _vm._v(" "), (module.locked_date) ? _c('v-list-tile-sub-title', [_vm._v("locked on " + _vm._s(_vm.moment(module.locked_date).format('YYYY-MM-DD, HH:mm')))]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
        attrs: {
          "icon": "",
          "ripple": "",
          "disabled": module.locked_date
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.moduleToLock = _vm.clone(module);
            _vm.lockDialog = true
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "green lighten-1"
        }
      }, [_vm._v("lock")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
        attrs: {
          "icon": "",
          "ripple": ""
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.moduleToDelete = _vm.clone(module);
            _vm.deleteDialog = true
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "grey lighten-1"
        }
      }, [_vm._v("delete")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < teamModules.length) ? _c('v-divider', {
        key: module.id + '-'
      }) : _vm._e()]
    }), _vm._v(" "), (teamModules.length === 0) ? _c('v-card-text', {
      staticClass: "Aligner",
      staticStyle: {
        "height": "60px"
      }
    }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.addDialog),
      callback: function($$v) {
        _vm.addDialog = $$v
      },
      expression: "addDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Add a module")]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Module name",
      "required": "",
      "error-messages": _vm.nameErrors,
      "blur": "$v.moduleToAddName.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.moduleToAddName.$touch()
      }
    },
    model: {
      value: (_vm.moduleToAddName),
      callback: function($$v) {
        _vm.moduleToAddName = $$v
      },
      expression: "moduleToAddName"
    }
  }), _vm._v(" "), (_vm.teams.length > 0) ? _c('div', [_c('v-radio-group', {
    attrs: {
      "mandatory": false
    },
    model: {
      value: (_vm.moduleToAddType),
      callback: function($$v) {
        _vm.moduleToAddType = $$v
      },
      expression: "moduleToAddType"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Personal",
      "value": "personal"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Team",
      "value": "team"
    }
  })], 1), _vm._v(" "), (_vm.moduleToAddType === 'team') ? _c('v-select', {
    attrs: {
      "label": "Team",
      "items": _vm.teams,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.moduleToAddTeam),
      callback: function($$v) {
        _vm.moduleToAddTeam = $$v
      },
      expression: "moduleToAddTeam"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.formValid,
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addDialog = false;
        _vm.addModule()
      }
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-card-text', [_vm._v("Delete " + _vm._s(_vm.moduleToDelete.name) + " ?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false;
        _vm.deleteModule(_vm.moduleToDelete)
      }
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.lockDialog),
      callback: function($$v) {
        _vm.lockDialog = $$v
      },
      expression: "lockDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-card-text', [_vm._v("Lock '" + _vm._s(_vm.moduleToLock.name) + "' and all its dependencies? This action cannot be undone.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lockDialog = false;
        _vm.lockModule(_vm.moduleToLock)
      }
    }
  }, [_vm._v("Lock")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lockDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32e4339e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shdl/ShdlModuleList.vue
// module id = 1181
// module chunks = 1